module.exports = __webpack_public_path__ + "img/transactions.weekly.edde154b.png";